import { useGetInfoCategoryMasterData } from '@Domains/MasterData';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { ISubcommitteesFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { select, tidy } from '@tidyjs/tidy';
import { useWatch } from 'react-hook-form';
import { climateChangeGovernanceType } from 'src/Enum/EsgGreenhouse';
import { INFO_CATEGORY_MASTER_DATA } from 'src/Enum/MasterData';
import {
  SUBCOMMITTEE_COLUMNS,
  SUBCOMMITTEE_VISIBILITY,
} from './SubcommitteeColumns';
import { mappingSubcommitteesDataTable } from './utils';

const ClimateChangeStructureSubcommitteeTable = () => {
  const [{ data = [] }] = useGetInfoCategoryMasterData([
    INFO_CATEGORY_MASTER_DATA.SUB_COMMITTEE_ROLE,
  ]);

  const subcommitteeMasterData = tidy(data, select(['id', 'nameTh', 'nameEn']));

  const subcommittees =
    useWatch({
      name: 'climateChangeStructure.subcommitteeResponsibility.subcommittees',
    }) || ([] as ISubcommitteesFormValues[]);

  const {
    formState: { errors },
  } = useGreenhouseForm();

  const mapSubcommittee = mappingSubcommitteesDataTable(
    subcommittees,
    subcommitteeMasterData
  );

  const subcommitteesError =
    errors.climateChangeStructure?.subcommitteeResponsibility?.subcommittees;

  const hasClimateChangeGovernance = subcommittees.some(
    (subcommittee: {
      subcommitteeRoles: {
        infoCategoryMasterDataId: climateChangeGovernanceType;
      }[];
    }) =>
      Array.isArray(subcommittee.subcommitteeRoles) &&
      subcommittee.subcommitteeRoles.some(
        (role: { infoCategoryMasterDataId: climateChangeGovernanceType }) =>
          role.infoCategoryMasterDataId ===
          climateChangeGovernanceType.CLIMATE_CHANGE_GOVERNANCE
      )
  );

  return (
    <Box mt={3}>
      <DataGrid
        rows={mapSubcommittee ?? []}
        columns={SUBCOMMITTEE_COLUMNS}
        getRowHeight={() => 'auto'}
        disableColumnSorting
        initialState={{
          columns: { columnVisibilityModel: SUBCOMMITTEE_VISIBILITY },
        }}
      />
      {Array.isArray(subcommitteesError) ? (
        !hasClimateChangeGovernance ? (
          <Typography variant={'caption'} color={'error.main'}>
            บริษัทต้องมีการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ จึงสามารถทำ
            Corporate Value Up Plan ได้
          </Typography>
        ) : null
      ) : (
        subcommitteesError && (
          <Typography variant={'caption'} color={'error.main'}>
            {subcommitteesError.message}
          </Typography>
        )
      )}
    </Box>
  );
};

export default ClimateChangeStructureSubcommitteeTable;
